import React, { Component } from "react";

const getStyles = ({ x, y, radius, dotColor }) => ({
  left: x,
  top: y,
  width: radius * 2,
  height: radius * 2,
  borderRadius: radius,
  backgroundColor: dotColor
});

class Dot extends Component {
  render() {
    return (
      <div
        style={{
          position: "absolute",
          ...this.props.dotStyles,
          ...getStyles(this.props)
        }}
      />
    );
  }
}

export default Dot;
